module.exports = __webpack_public_path__ + "static/img/picture2.b5d17b66.png";